module.exports = __webpack_public_path__ + "img/nav_application_lyjq.85854688.png";